import React from 'react'
import { Redirect, Route } from 'react-router-dom'


const PrivateRoute = ({ isLoggedIn:isLoggedIn, component: Component, ...rest }) => {

  // Add your own authentication on the below line.

  return (
    <Route
      {...rest}
      render={props =>
        isLoggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: "/app/login", state: { from: props.location } }} />
        )
      }
    />
  )
}
  
  export default PrivateRoute;